import React from 'react';
import type { SingleValueProps } from 'react-select';
import { components } from 'react-select';
import classNames from 'classnames';

import type { ImageSelectOptionType } from 'js/src/components/common/ui/ImageSelect/ImageSelect';

const CustomImageValue = <T, Option extends ImageSelectOptionType<T>>(
    props: SingleValueProps<Option, boolean, any>,
) => {
    const hasNoIconUrl = props.data.picture_url === null;
    const { className, isDisabled, children } = props;
    const newClassName = classNames(
        {
            'single-value': true,
            'single-value--is-disabled': isDisabled,
        },
        'Select-value-label',
        'd-flex',
        'align-items-center',
        className,
    );
    return (
        <components.SingleValue className={newClassName} {...props}>
            <img
                src={props.data.picture_url ?? ''}
                className={classNames({ 'display-none': hasNoIconUrl })}
            />
            {children}
        </components.SingleValue>
    );
};

export default CustomImageValue;
